import styled from 'styled-components'
import oficinasSunat from '../imgs/oficinasSunat.jpg'
import logoSunat from '../imgs/logoSunat.png'




const Container=styled.div`
	overflow:auto;
	display:flex;
	justify-content:center;
	width:100%;	
	background-image:url(${oficinasSunat});
	background-repeat:no-repeat;
	background-size:cover;
	overflow:auto;
	&::-webkit-scrollbar{
		background-color:white;
		width:5px};
	::-webkit-scrollbar:vertical{display:none}
	::-webkit-scrollbar:horizontal{display:none}
 `;
const Glass=styled.div`
	position:relative;
	background-color: rgba(255, 255, 255,0.1);
	backdrop-filter: blur(7px);
	boxShadow:0 10px 20px 5px rgba(0,0,0,0.3); 
	border:solid 1px rgba(255,255,255,0.3);
	border-radius:15px;
	width:99vw;
	height:84vh;
	margin:5px; 
	display:flex;
	flex-direction:column;
	align-items:center;
	justify-content:center;
	overflow:hidden;
    
  

	@media (max-width: 900px) {
    display:none; 
  }
`;

const GlassSunat=styled.div`
	height:200%;
	width:100%;
	position:absolute;
	background-image:url(${logoSunat});
	background-size:150px;
	transform:rotate(-35deg);
	opacity:0.08;



  `;


const Container1=styled.div`
	width:90%;
	overflow:auto;
	display:flex;
	height:84vh;	
	background-color:white;	
	border-radius:8px;
	overflow:auto;
	
	z-index:1;
	&::-webkit-scrollbar{
		background-color:transparent;
		width:1px};
	::-webkit-scrollbar-thumb{
		background:#01578c;
		border-radius:25px};
	::-webkit-scrollbar:horizontal{display:none}
 `;
  





export default function ConsultaValidez(){



	return (
		
		<Container>
			<Glass>
				<GlassSunat/>
				<Container1>
					<iframe title="sunat" src="https://ww1.sunat.gob.pe/ol-ti-itconsultaunificadalibre/consultaUnificadaLibre/consulta"   width="100%" height="99.4%" ></iframe>
				</Container1>
			</Glass>
				
			
		</Container>
		
	)
}